import React, { Component } from "react";
import { connect } from "react-redux";
import SubjectDetail from "../PrincipalDashboard/dashboard/components/subject-detail";
import MasterSubjectDetail from "pages/MasterDashboard/dashboard/components/subject-detail";

// import {
//     getUserProfile,
//     saveUserDataToLocalStorage,
//     getSelectedBoardAndGradeFromLocal,
//   } from '../../services/dataServices/userProfileService'
//   import {SuperAdminLogindata,TeacherLogindata} from '../Login/userData/index'

const mapStateToProps = (state) => {
  // const user = state.auth.user;
  return {
    userType: state.user.user_type,
  };
};

export class SubjectMain extends Component {
  // async componentDidMount(){
  //     var Logindata = TeacherLogindata
  //     await saveUserDataToLocalStorage(Logindata);
  // }
  render() {
    const userType = this.props.userType;
    if (userType === "principal") {
      return (
        <div>
          <SubjectDetail />
        </div>
      );
    }
    if (userType === "teacher") {
      return (
        <div>
          <SubjectDetail />
        </div>
      );
    } else if (userType === "superadmin") {
      return (
        <div>
          <MasterSubjectDetail />
        </div>
      );
    } else {
      return <></>;
    }
  }
}

export default connect(mapStateToProps, null)(SubjectMain);
